import {
  collection,
  onSnapshot,
  FirestoreError,
  query,
  Unsubscribe,
} from "firebase/firestore";
import { db } from "../../firebase";
import { EntityGet, EntityServerGet, ListServiceOpts } from "../../types";
import { Frequentmessage } from "./types";
import { transformMetadata, processTimestampFields } from "../../utils";

export type FrequentmessageOnSnapshotCollectionService<T> = (
  agentId: string,
  opts: ListServiceOpts,
  callback: (docs: Array<T>) => void,
  onError?: (error: FirestoreError) => void
) => Unsubscribe;

const onSnapshotCollection: FrequentmessageOnSnapshotCollectionService<
  EntityGet<Frequentmessage>
> = (agentId, opts: ListServiceOpts, callback, onError = () => {}) => {
  const collectionRef = collection(db, `/agent/${agentId}/frequentmessage`);
  const { disableCache } = opts;
  const q = opts.listQueryFn
    ? opts.listQueryFn(collectionRef)
    : query(collectionRef);
  return onSnapshot(
    q,
    { includeMetadataChanges: disableCache },
    (querySnap) => {
      const { metadata } = querySnap;
      const { fromCache } = metadata;
      if (disableCache && fromCache) return;
      callback(
        querySnap.docs.map(
          (doc) =>
            processTimestampFields(
              transformMetadata(
                {
                  ...doc.data(),
                  id: doc.id,
                } as EntityServerGet<Frequentmessage>,
                doc.metadata
              )
            ) as EntityGet<Frequentmessage>
        )
      );
    },
    onError
  );
};

export default onSnapshotCollection;
